import React, { Component } from "react";
import { Container, Navbar, Tabs, Spinner, Form, Badge } from "react-bootstrap";
import { Nav } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Tab } from "react-bootstrap";
import ProfitBreakdownViewer from "./ProfitBreakdownViewer";

import { connect } from "react-redux";
import ProfitBreakdownViewFilter from "./ProfitBreakdownViewFilter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faPlus,
  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { toastr } from "react-redux-toastr";
import moment from "moment";

import { openModal, closeModal } from "../../../store/actions/ModalActions";
import { v4 as uuidv4 } from "uuid";
import { RenderClusterColumns } from "./ProfitBreakdownColumnGenerator";

import {
  GetProfitBreakdownOverall,
  GetProfitBreakdownCluster,
  GetProfitBreakdownArea,
  GetProfitBreakdownBranch,
  GetProfitBreakdownBranchConcurrentRequest,
} from "../../../store/actions/reports/profit_breakdown_service_actions";
import {
  GetProfitBreakdownOverall_v3,
  GetProfitBreakdownCluster_v3,
  GetProfitBreakdownArea_v3,
  GetProfitBreakdownBranch_v3,
} from "../../../store/actions/reports-v3/profit_breakdown_service_actions";
import {
  GetProfitBreakdownOverall_v4,
  GetProfitBreakdownCluster_v4,
  GetProfitBreakdownArea_v4,
  GetProfitBreakdownBranch_v4,
} from "../../../store/actions/reports-v4/profit_breakdown_service_actions";
import NoTabItem from "../../../components/extensions/ErrorPageDefaults/NoTabItem";

import {
  GetPeppHierarchy,
  GetClusters,
} from "../../../store/actions/crdm_service_actions";

import { Link } from "react-router-dom";

const createTab = (uuid, name, searchBy, list, covered_date, filename) => {
  return { uuid, name, searchBy, list, covered_date, filename };
};

const currentDate = new Date(new Date().setDate(new Date().getDate() - 1));

class ProfitBreakdownViewLayout extends Component {
  state = {
    isLoading: false,
    covered_date: currentDate,
    tabItems: [],
    lastAdded: null,
  };

  removeTab = (data) => {
    let { tabItems } = this.state;
    const index = tabItems.indexOf(data);
    tabItems.splice(index, 1);
    this.setState({ tabItems });
  };

  addView = (title, searchBy, list, covered_date, filename) => {
    let { tabItems } = this.state;
    tabItems.push(
      createTab(uuidv4(), title, searchBy, list, covered_date, filename)
    );
    this.setState({ tabItems, lastAdded: tabItems.length - 1 });
  };

  // componentDidMount() {
  //   this.setState({ isLoading: true });
  //   this._getOverallBreakdown(
  //     moment(this.state.covered_date).format("MMMM DD YYYY")
  //   ).then(() => {
  //     this.setState({ isLoading: false });
  //   });
  // }

  renderTimeOutError = () => {
    setTimeout(() => {
      openModal({
        title: "Request Timed Out",
        size: "lg",
        currentComponent: (
          <div>
            <p>
              The request has timed out. Please try generating the report again.
            </p>

            <Button className="float-right mt-3" onClick={closeModal}>
              Ok
            </Button>
          </div>
        ),
      });
    }, 100);
  };

  _getClusterBreakdown = async (clusterIds, covered_date) => {
    let requestList = [];
    let _clusterIds = clusterIds;
    _clusterIds.forEach((cluster_id) => {
      this.setState({ isLoading: true });
      requestList.push(
        this.premisefetchProfitBreakdownByClusterV4({
          covered_date: covered_date,
          clusterId: cluster_id,
          isRange: false,
        }).then((areaList) => {
          if (areaList.problem === null) {
            this.setState({ isLoading: false }, () => {
              this.addView(
                `Cluster ${cluster_id}`,
                "Area",
                areaList.data,
                moment(covered_date).format("MMMM DD, YYYY"),
                `Gross Income Breakdown ${moment(covered_date).format(
                  "MM.DD.YYYY"
                )}`
              );
            });
            return areaList.data;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getAreaBreakdown = async (areaIds, covered_date) => {
    let requestList = [];
    let _areaIds = areaIds;

    _areaIds.forEach((area_id) => {
      this.setState({ isLoading: true });
      requestList.push(
        this.premisefetchProfitBreakdownByAreaV4({
          covered_date: covered_date,
          area_code: area_id,
          isRange: false,
        }).then((branchList) => {
          if (branchList.problem === null) {
            this.setState({ isLoading: false }, () => {
              this.addView(
                `Area ${area_id}`,
                "Branch",
                branchList.data,
                moment(covered_date).format("MMMM DD, YYYY"),
                `Gross Income Breakdown ${moment(covered_date).format(
                  "MM.DD.YYYY"
                )}`
              );
            });
            return branchList.data;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getAreaBreakdownOptimized = async (areas, covered_date) => {
    let requestList = [];
    this.setState({ isLoading: true });
    areas.forEach((data) => {
      const chunkSize = 5;
      const branchCodechunks = [];

      for (let i = 0; i < data.branchCodes.length; i += chunkSize) {
        const chunk = data.branchCodes.slice(i, i + chunkSize);
        branchCodechunks.push(chunk);
      }
      requestList.push(
        this.premisefetchProfitBreakdownByBranchConcurrentRequest({
          covered_date: covered_date,
          branchCodechunks,
        }).then((responseList) => {
          if (!responseList.find((response) => response.problem !== null)) {
            const branchList = responseList.flatMap(
              (response) => response.data
            );
            this.addView(
              `Area ${data.area_code}`,
              "Branch",
              branchList,
              moment(covered_date).format("MMMM DD, YYYY"),
              `Gross Income Breakdown ${moment(covered_date).format(
                "MM.DD.YYYY"
              )}`
            );

            this.setState({ isLoading: false });

            return branchList;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getOverallBreakdown = (covered_date) => {
    return this.premisefetchProfitBreakdownSummaryOverallV4({
      covered_date: covered_date ? covered_date : this.state.covered_date,
      isRange: false,
    }).then((clusterList) => {
      if (clusterList.problem === null) {
        this.addView(
          "All",
          "All",
          clusterList.data,
          moment(covered_date ? covered_date : this.state.covered_date).format(
            "MMMM DD, YYYY"
          ),
          `Gross Income Breakdown ${moment(covered_date).format("MM.DD.YYYY")}`
        );
      } else {
        this.renderTimeOutError();
      }
    });
  };

  _getBranchBreakdown = async (branch_codes, covered_date) => {
    this.setState({ isLoading: true });
    return await this.premisefetchInventoryDetailsByBranchV4({
      covered_date: covered_date,
      branch_codes: branch_codes,
      isRange: false,
    }).then((branchList) => {
      if (branchList.problem === null) {
        this.addView(
          `Branch ${branch_codes}`,
          "Branch",
          branchList.data,
          moment(covered_date).format("MMMM DD, YYYY"),
          `Gross Income Breakdown ${moment(covered_date).format("MM.DD.YYYY")}`
        );
        this.setState({ isLoading: false });
      } else {
        this.renderTimeOutError();
      }
    });
  };

  _getClusterBreakdownDateRange = async (clusterIds, from, to) => {
    let requestList = [];
    let _clusterIds = clusterIds;
    _clusterIds.forEach((cluster_id) => {
      this.setState({ isLoading: true });
      requestList.push(
        this.premisefetchProfitBreakdownByClusterV4({
          from,
          to,
          clusterId: cluster_id,
          isRange: true,
        }).then((areaList) => {
          if (areaList.problem === null) {
            this.setState({ isLoading: false }, () => {
              this.addView(
                `Cluster ${cluster_id}`,
                "Area",
                areaList.data,
                `${moment(from).format("MMMM DD, YYYY")} to ${moment(to).format(
                  "MMMM DD, YYYY"
                )}`,
                `Gross Income Breakdown ${moment(from).format(
                  "MM.DD.YYYY"
                )} - ${moment(to).format("MM.DD.YYYY")}`
              );
            });
            return areaList.data;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getAreaBreakdownDateRange = async (areaIds, from, to) => {
    let requestList = [];
    let _areaIds = areaIds;

    _areaIds.forEach((area_id) => {
      this.setState({ isLoading: true });
      requestList.push(
        this.premisefetchProfitBreakdownByAreaV3({
          from,
          to,
          area_code: area_id,
          isRange: true,
        }).then((branchList) => {
          if (branchList.problem === null) {
            this.setState({ isLoading: false }, () => {
              this.addView(
                `Area ${area_id}`,
                "Branch",
                branchList.data,
                `${moment(from).format("MMMM DD, YYYY")} to ${moment(to).format(
                  "MMMM DD, YYYY"
                )}`,
                `Gross Income Breakdown ${moment(from).format(
                  "MM.DD.YYYY"
                )} - ${moment(to).format("MM.DD.YYYY")}`
              );
            });
            return branchList.data;
          } else {
            this.renderTimeOutError();
          }
        })
      );
    });
    await Promise.all(requestList);
    return await Promise.resolve();
  };

  _getOverallBreakdownDateRange = async (from, to) => {
    return await this.premisefetchProfitBreakdownSummaryOverallV3({
      from,
      to,
      isRange: true,
    }).then((clusterList) => {
      if (clusterList.problem === null) {
        this.addView(
          "All",
          "All",
          clusterList.data,
          `${moment(from).format("MMMM DD, YYYY")} to ${moment(to).format(
            "MMMM DD, YYYY"
          )}`,
          `Gross Income Breakdown ${moment(from).format(
            "MM.DD.YYYY"
          )} - ${moment(to).format("MM.DD.YYYY")}`
        );
      } else {
        this.renderTimeOutError();
      }
    });
  };

  _getBranchBreakdownDateRange = async (branch_codes, from, to) => {
    console.log(from, to);
    this.setState({ isLoading: true });
    return await this.premisefetchInventoryDetailsByBranchV3({
      from,
      to,
      branch_codes: branch_codes,
      isRange: true,
    }).then((branchList) => {
      if (branchList.problem === null) {
        this.addView(
          `Branch ${branch_codes}`,
          "Branch",
          branchList.data,
          `${moment(from).format("MMMM DD, YYYY")} to ${moment(to).format(
            "MMMM DD, YYYY"
          )}`,
          `Gross Income Breakdown ${moment(from).format(
            "MM.DD.YYYY"
          )} - ${moment(to).format("MM.DD.YYYY")}`
        );
        this.setState({ isLoading: false });
      } else {
        this.renderTimeOutError();
      }
    });
  };

  render() {
    return (
      <Container
        className="bg-light p-2 rounded shadow-sm"
        fluid
        style={{ minHeight: 500 }}
      >
        <Navbar className="rounded">
          <Navbar.Brand>
            <Link className="mr-2" to="/pawnshop-reports/reports">
              <Button variant="outline-secondary">
                <FontAwesomeIcon icon={faArrowLeft} />
              </Button>
            </Link>
            Gross Income Breakdown
          </Navbar.Brand>
          <Navbar.Collapse>
            <Nav />
            <Nav className="mr-auto" />
          </Navbar.Collapse>
          <Form inline>
            <Button
              size="md"
              variant="success"
              onClick={() => {
                openModal({
                  title: "New Gross Income Breakdown Report",
                  size: "lg",
                  currentComponent: (
                    <ProfitBreakdownViewFilter
                      getByOverall={this._getOverallBreakdown}
                      getByBranch={this._getBranchBreakdown}
                      getByArea={this._getAreaBreakdown}
                      getByAreaOptimized={this._getAreaBreakdownOptimized}
                      getByCluster={this._getClusterBreakdown}
                      getByOverallDateRange={this._getOverallBreakdownDateRange}
                      getByBranchDateRange={this._getBranchBreakdownDateRange}
                      getByAreaDateRange={this._getAreaBreakdownDateRange}
                      getByClusterDateRange={this._getClusterBreakdownDateRange}
                    />
                  ),
                });
              }}
            >
              <FontAwesomeIcon icon={faPlus} className="mr-1" />
              New Gross Income Breakdown Report
            </Button>
          </Form>
        </Navbar>
        {this.state.tabItems.length > 0 ? (
          <Tabs
            className="mt-2"
            activeKey={this.state.lastAdded}
            onSelect={(idx) => this.setState({ lastAdded: idx })}
          >
            {this.state.tabItems.map((data, idx) => {
              var column = RenderClusterColumns(data.list, data.searchBy);

              return (
                <Tab
                  key={idx}
                  className="bg-white"
                  eventKey={idx}
                  title={
                    <div>
                      <Spinner
                        className="mr-2"
                        animation="border"
                        size="sm"
                        hidden={!this.state.isLoading}
                      />
                      {`${data.name}`}
                      <Badge className="ml-2 p-2" variant="light">
                        {" "}
                        {data.covered_date}
                      </Badge>
                      <Button
                        className="ml-3"
                        size="sm"
                        variant="light"
                        onClick={() => {
                          toastr.confirm(
                            "Are you sure you want to close this tab?",
                            {
                              onOk: () => this.removeTab(data),
                              okText: "Yes, close it",
                            }
                          );
                        }}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                      </Button>
                    </div>
                  }
                >
                  <ProfitBreakdownViewer
                    column={column}
                    data={data}
                    tabIndex={idx}
                  />
                </Tab>
              );
            })}
          </Tabs>
        ) : (
          <NoTabItem appendText="New Gross Income Breakdown Report" />
        )}
      </Container>
    );
  }

  premiseGetClusters = () => {
    return this.props.GetClusters();
  };

  premisefetchProfitBreakdownSummaryOverall = (data) => {
    return this.props.GetProfitBreakdownOverall({
      covered_date: data.covered_date,
    });
  };

  premisefetchProfitBreakdownByCluster = (data) => {
    return this.props.GetProfitBreakdownCluster({
      covered_date: data.covered_date,
      clusterId: data.clusterId,
    });
  };

  premisefetchProfitBreakdownByArea = (data) => {
    return this.props.GetProfitBreakdownArea({
      covered_date: data.covered_date,
      area_code: data.area_code,
    });
  };

  premisefetchProfitBreakdownByBranchConcurrentRequest = (data) => {
    return this.props.GetProfitBreakdownBranchConcurrentRequest({
      covered_date: data.covered_date,
      branchCodechunks: data.branchCodechunks,
    });
  };

  premisefetchInventoryDetailsByBranch = (data) => {
    return this.props.GetProfitBreakdownBranch({
      covered_date: data.covered_date,
      branch_codes: data.branch_codes,
    });
  };

  premisefetchProfitBreakdownSummaryOverallV3 = (data) => {
    return this.props.GetProfitBreakdownOverall_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
    });
  };

  premisefetchProfitBreakdownByClusterV3 = (data) => {
    return this.props.GetProfitBreakdownCluster_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
      clusterId: data.clusterId,
    });
  };

  premisefetchProfitBreakdownByAreaV3 = (data) => {
    return this.props.GetProfitBreakdownArea_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
      area_code: data.area_code,
    });
  };

  premisefetchInventoryDetailsByBranchV3 = (data) => {
    return this.props.GetProfitBreakdownBranch_v3({
      dates: {
        from: data.from,
        to: data.to,
      },
      branch_codes: data.branch_codes,
    });
  };

  premisefetchProfitBreakdownSummaryOverallV4 = (data) => {
    return this.props.GetProfitBreakdownOverall_v4({
      dates: {
        from: data.from,
        to: data.to,
      },
      covered_date: data.covered_date,
      isRange: data.isRange,
    });
  };

  premisefetchProfitBreakdownByClusterV4 = (data) => {
    return this.props.GetProfitBreakdownCluster_v4({
      dates: {
        from: data.from,
        to: data.to,
      },
      covered_date: data.covered_date,
      clusterId: data.clusterId,
      isRange: data.isRange,
    });
  };

  premisefetchProfitBreakdownByAreaV4 = (data) => {
    return this.props.GetProfitBreakdownArea_v4({
      dates: {
        from: data.from,
        to: data.to,
      },
      covered_date: data.covered_date,
      area_code: data.area_code,
      isRange: data.isRange,
    });
  };

  premisefetchInventoryDetailsByBranchV4 = (data) => {
    return this.props.GetProfitBreakdownBranch_v4({
      dates: {
        from: data.from,
        to: data.to,
      },
      covered_date: data.covered_date,
      branch_codes: data.branch_codes,
      isRange: data.isRange,
    });
  };
}

const mapStateToProps = (state) => {
  return {
    clusters: state.crdm.cluster,
    areas: state.crdm.area,
  };
};

const mapDispatchToProps = {
  GetPeppHierarchy: GetPeppHierarchy,
  GetClusters: GetClusters,

  GetProfitBreakdownOverall: GetProfitBreakdownOverall,
  GetProfitBreakdownCluster: GetProfitBreakdownCluster,
  GetProfitBreakdownArea: GetProfitBreakdownArea,
  GetProfitBreakdownBranch: GetProfitBreakdownBranch,
  GetProfitBreakdownBranchConcurrentRequest:
    GetProfitBreakdownBranchConcurrentRequest,

  GetProfitBreakdownOverall_v3: GetProfitBreakdownOverall_v3,
  GetProfitBreakdownCluster_v3: GetProfitBreakdownCluster_v3,
  GetProfitBreakdownArea_v3: GetProfitBreakdownArea_v3,
  GetProfitBreakdownBranch_v3: GetProfitBreakdownBranch_v3,

  GetProfitBreakdownOverall_v4: GetProfitBreakdownOverall_v4,
  GetProfitBreakdownCluster_v4: GetProfitBreakdownCluster_v4,
  GetProfitBreakdownArea_v4: GetProfitBreakdownArea_v4,
  GetProfitBreakdownBranch_v4: GetProfitBreakdownBranch_v4,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfitBreakdownViewLayout);
